import { render, staticRenderFns } from "./ApplicableVehicleType.vue?vue&type=template&id=004c6364&scoped=true"
import script from "./ApplicableVehicleType.vue?vue&type=script&lang=js"
export * from "./ApplicableVehicleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c6364",
  null
  
)

export default component.exports